import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PagedResultDto } from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import {
  JobPosting,
  JobPostingDetailDto,
  JobPostingSearchParams
} from '../models/';

@Injectable({ providedIn: 'root' })
export class JobPostingsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/job-postings';

  getAll(
    params?: JobPostingSearchParams
  ): Observable<PagedResultDto<JobPosting>> {
    return this.http.get<PagedResultDto<JobPosting>>(this.apiUrl, {
      params: HttpHelper.toHttpParams(params ?? {})
    });
  }

  getById(id: string): Observable<JobPostingDetailDto> {
    return this.http.get<JobPostingDetailDto>(`${this.apiUrl}/${id}`);
  }

  markInterested(id: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/interest`, {});
  }

  withdrawInterest(id: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/withdraw`, {});
  }
}
